"use strict";

var _classCallCheck = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _get = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var _require = require("../helpers/strings"),
    stripAndCollapseASCIIWhitespace = _require.stripAndCollapseASCIIWhitespace;

var _require2 = require("../helpers/internal-constants"),
    domSymbolTree = _require2.domSymbolTree;

var _require3 = require("../helpers/traversal"),
    closest = _require3.closest;

var HTMLOptionElementImpl = /*#__PURE__*/function (_HTMLElementImpl) {
  _inherits(HTMLOptionElementImpl, _HTMLElementImpl);

  var _super = _createSuper(HTMLOptionElementImpl);

  function HTMLOptionElementImpl(args, privateData) {
    var _this;

    _classCallCheck(this, HTMLOptionElementImpl);

    _this = _super.call(this, args, privateData); // whenever selectedness is set to true, make sure all
    // other options set selectedness to false

    _this._selectedness = false;
    _this._dirtyness = false;
    return _this;
  }

  _createClass(HTMLOptionElementImpl, [{
    key: "_removeOtherSelectedness",
    value: function _removeOtherSelectedness() {
      // Remove the selectedness flag from all other options in this select
      var select = this._selectNode;

      if (select && !select.hasAttribute("multiple")) {
        var _iterator = _createForOfIteratorHelper(select.options),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var option = _step.value;

            if (option !== this) {
              option._selectedness = false;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }, {
    key: "_askForAReset",
    value: function _askForAReset() {
      var select = this._selectNode;

      if (select) {
        select._askedForAReset();
      }
    }
  }, {
    key: "_attrModified",
    value: function _attrModified(name) {
      if (!this._dirtyness && name === "selected") {
        this._selectedness = this.hasAttribute("selected");

        if (this._selectedness) {
          this._removeOtherSelectedness();
        }

        this._askForAReset();
      }

      _get(_getPrototypeOf(HTMLOptionElementImpl.prototype), "_attrModified", this).apply(this, arguments);
    }
  }, {
    key: "_selectNode",
    get: function get() {
      var select = domSymbolTree.parent(this);

      if (!select) {
        return null;
      }

      if (select.nodeName.toUpperCase() !== "SELECT") {
        select = domSymbolTree.parent(select);

        if (!select || select.nodeName.toUpperCase() !== "SELECT") {
          return null;
        }
      }

      return select;
    }
  }, {
    key: "form",
    get: function get() {
      return closest(this, "form");
    }
  }, {
    key: "text",
    get: function get() {
      // TODO is not correctly excluding script and SVG script descendants
      return stripAndCollapseASCIIWhitespace(this.textContent);
    },
    set: function set(V) {
      this.textContent = V;
    }
  }, {
    key: "value",
    get: function get() {
      return this.hasAttribute("value") ? this.getAttribute("value") : this.text;
    },
    set: function set(val) {
      this.setAttribute("value", val);
    }
  }, {
    key: "index",
    get: function get() {
      var select = closest(this, "select");

      if (select === null) {
        return 0;
      }

      return select.options.indexOf(this);
    }
  }, {
    key: "selected",
    get: function get() {
      return this._selectedness;
    },
    set: function set(s) {
      this._dirtyness = true;
      this._selectedness = Boolean(s);

      if (this._selectedness) {
        this._removeOtherSelectedness();
      }

      this._askForAReset();
    } // TODO this is quite wrong

  }, {
    key: "label",
    get: function get() {
      if (this.hasAttribute("label")) {
        return this.getAttribute("label");
      }

      var select = this._selectNode;

      if (select) {
        return select.getAttribute("label");
      }

      return null;
    },
    set: function set(V) {
      var select = this._selectNode;

      if (select) {
        select.setAttribute("label", V);
      }
    }
  }]);

  return HTMLOptionElementImpl;
}(HTMLElementImpl);

module.exports = {
  implementation: HTMLOptionElementImpl
};